module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c4ij0"))).then(() => parcelRequire('d0iPb'));